import { Task } from "@/api/mutation/useTaskCreateMutation";
import PercentageCircle from "@/components/shared/PercentageCircle";
import Table, { ColumeDef } from "@/components/shared/Table";
import TaskSubTaskForm from "@/components/tasks/taskSubTaskForm";
import { Button } from "@/components/ui/button";
import dateFormater from "@/helperFuntions/dateFormater";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Dialog from "@/components/common/Dialog";
import useRemoveTaskMutation from "@/api/mutation/useTaskRemove";
import TrashCan from "../../assets/svg/TrashCan.svg";
import Edit from "../../assets/svg/NewEditIcon.svg";
import { toast } from "react-toastify";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import UserAvatar from "@/components/ui/userAvatar";
import {
  ProjectDefaultViewEnumValue,
  TaskStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import Loader from "@/components/common/Loader";
import { useUser } from "@/hooks/useUser";
import useAllMyTaskQuery from "@/api/query/useMyTaskQuery";
import calendar from "../../assets/svg/CalenderNewIcon.svg";
import list from "../../assets/svg/listNew.svg";
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import Scheduler, { SchedulerEvent } from "smart-webcomponents-react/scheduler";
import TaskFilter from "@/components/views/TaskFilter";
import "@/components/views/calendarView/index.css";
import { FIELDS } from "@/api/types/enums";
import "@/components/views/calendarView/index.css";
import { errorConfig } from "@/lib/toastError";
import RedFlag from "@/assets/svg/RedFlag.svg";
import SubtaskArrow from "@/assets/svg/SubtaskArrow.svg";
import OrangeFlag from "@/assets/svg/OrangeFlag.svg";
import GreenFlag from "@/assets/svg/GreenFlag.svg";
import NewEditIcon from "@/assets/svg/NewEditIcon.svg";
import { useTranslation } from "react-i18next";
import useMultipaleTaskRemoveMutation from "@/api/mutation/useMultipleTaskRemoveMutation";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import FullScreen from "@/assets/v2/svg/full-screen.svg";
import ExitFullscreen from "@/assets/svg/ExitFullscreen.svg";
import Refresh from "@/assets/v2/svg/refresh.svg";
import ExcelJS from "exceljs";
import ExcelIcon from "@/assets/v2/svg/excel.svg";
import DownLoadIcon from "@/assets/svg/DownLoad.svg";
import Collaps from "@/assets/v2/svg/collaps.svg";
import Expand from "@/assets/v2/svg/expand.svg";
import { useOutsideClick } from "@/helperFuntions/clickOutsideHook";
import useProjectWithoutCalulationQuery from "@/api/query/useProjectWithoutCalulationQuery";

function MyTasks() {
  const [taskData, setTaskData] = useState<Task[]>();
  const [filterData, setFilterData] = useState<Task[] | undefined>();
  const [dataSource, setDataSource] = useState<SchedulerEvent[]>();
  const [taskId, setTaskId] = useState<string | undefined>();
  const [projectId, setProjectId] = useState<string | undefined>();
  const [taskCreate, setTaskCreate] = useState<boolean>(false);
  const [dialogRendered, setDialogRendered] = useState<string | undefined>(
    undefined,
  );
  const { t, i18n } = useTranslation();
  const [startDate, setStartDate] = useState<Date>();
  const [isFullscreen, setIsFullscreen] = useState(false);

  const allTaskQuery = useAllMyTaskQuery();
  const [showConfirmDelete, setShowConfirmDelete] = useState<string | null>(
    null,
  );

  const [remove, setRemove] = useState(false);

  const user = useUser();
  const projects = useProjectWithoutCalulationQuery(false);
  const isTaskProjectInactive = useCallback((task: Task | undefined) => {
    if (!task) return false;
    const project = projects.data?.data.data.find(
      (p) => p.projectId === task.projectId
    );
    return project ? !project.isActive : false;
  }, [projects.data?.data.data]);

  // const projectDetailQuery = useProjectDetail(projectId);
  // const verification = () => {
  //   if (user.user?.userOrganisation[0].role === UserRoleEnumValue.ADMINISTRATOR) {
  //     return true;
  //   } else {
  //     const projectMenager =
  //       projectDetailQuery.data?.data.data.assignedUsers.find((item) => {
  //         if (
  //           item.projectRole === UserRoleEnumValue.PROJECT_MANAGER &&
  //           user.user?.userId === item.user.userId
  //         ) {
  //           console.log(item);
  //           return item;
  //         }
  //       });

  //     if (projectMenager) {
  //       return true;
  //     }
  //   }
  //   return false;
  // };
  const findTaskById = (tasks: Task[] | undefined, id: string): Task | null => {
    if (!tasks) return null;
    for (const t of tasks) {
      if (t.taskId === id) return t;
      const found = findTaskById(t.subtasks, id);
      if (found) return found;
    }
    return null;
  };

  const onItemClick = (e: (Event & CustomEvent) | undefined) => {
    e?.preventDefault();

    if (!e?.detail.item.id) {
      setDialogRendered(undefined);
      setStartDate(e?.detail.item.dateStart);
    } else {
      const taskIdFromCalendar = e?.detail.item.id;
      setDialogRendered(taskIdFromCalendar);
      const task = findTaskById(filterData ?? [], taskIdFromCalendar);
      if (task?.projectId) setProjectId(task.projectId);
    }
  };
  const viewOption = [
    {
      icon: list,
      value: ProjectDefaultViewEnumValue.LIST,
    },
    {
      icon: calendar,
      value: ProjectDefaultViewEnumValue.CALENDAR,
    },
  ];
  const [views, setViews] = useState<string>(viewOption[0].value);
  const close = () => {
    setTaskId(undefined);
    setProjectId(undefined);
    setTaskCreate(false);
    setDialogRendered(undefined);
    allTaskQuery.refetch();
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);

      const navbar = document.getElementById("navbar");
      const sidebar = document.getElementById("Sidebar");

      if (document.fullscreenElement) {
        if (navbar) navbar.classList.add("!hidden");
        if (sidebar) sidebar.classList.add("!hidden");
      } else {
        if (navbar) navbar.classList.remove("!hidden");
        if (sidebar) sidebar.classList.remove("!hidden");
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    setDataSource(
      filterData?.map((d) => {
        return DataConvertToScheduler(d);
      }),
    );
  }, [filterData]);
  const [selectedTasks, setSelectedTasks] = useState<string[]>([]);
  const columnDef: ColumeDef[] = [
    {
      key: "taskId",
      header: " ",
      onHeaderRender: () => (
        <div className="flex justify-center items-center w-full">
          <input
            type="checkbox"
            onChange={(e) => {
              if (e.target.checked) {
                const ids = (filterData ?? []).flatMap((t) =>
                  t.subtasks?.length
                    ? [t.taskId, ...t.subtasks.map((s) => s.taskId)]
                    : [t.taskId],
                );
                setSelectedTasks(ids);
              } else {
                setSelectedTasks([]);
              }
            }}
            checked={(() => {
              const allIds = (filterData ?? []).flatMap((t) => [
                t.taskId,
                ...(t.subtasks ?? []).map((s) => s.taskId),
              ]);
              return (
                allIds.length > 0 &&
                allIds.every((id) => selectedTasks.includes(id))
              );
            })()}
          />
        </div>
      ),
      onCellRender: (data: Task) => {
        return (
          <div className="w-fit">
            <input
              key={data.taskId}
              type="checkbox"
              onChange={() => {
                onSelectTask(data.taskId);
              }}
              disabled={!allowed(data)}
              checked={selectedTasks.includes(data.taskId)}
            />
          </div>
        );
      },
    },
    {
      key: "flag",
      header: t("flag"),
      sorting: true,
      onCellRender: (item: Task) => (
        <div className={`cursor-pointer w-6 max-w-6 flex items-center gap-1`}>
          {item.parentTaskId && (
            <img src={SubtaskArrow} className={"h-5 w-5 min-w-5"} />
          )}
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild>
                {item?.milestoneIndicator ? (
                  <div
                    className={`h-3.5 w-3.5 min-w-3.5 rounded-sm rotate-45  ${
                      item?.flag == "Green"
                        ? "bg-flag-green"
                        : item?.flag == "Red"
                          ? "bg-flag-red"
                          : item?.flag == "Orange"
                            ? "bg-flag-orange"
                            : ""
                    }`}
                  ></div>
                ) : item?.flag == "Green" ? (
                  <img src={GreenFlag} className="h-4 w-4" />
                ) : item?.flag == "Red" ? (
                  <img src={RedFlag} className="h-4 w-4" />
                ) : item?.flag == "Orange" ? (
                  <img src={OrangeFlag} className="h-4 w-4" />
                ) : (
                  ""
                )}
              </TooltipTrigger>
              <TooltipContent>
                {item?.flag == "Green"
                  ? t("ON_TIME")
                  : item?.flag == "Red"
                    ? t("SIGNIFICANT_DELAY")
                    : item?.flag == "Orange"
                      ? t("MODERATE_DELAY")
                      : ""}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      ),
    },
    {
      key: "taskName",
      header: t("task_name"),
      sorting: true,
      onHeaderRender: (header) => (
        <span className="font-medium text-gray-700">{header}</span>
      ),
      onCellRender: (item: Task) => {
        const isInactive = isTaskProjectInactive(item);
        return (
          <div
            className={`flex gap-2 items-center w-36 truncate ${isInactive ? "text-gray-400 cursor-not-allowed select-none" : "cursor-pointer text-blue-600 hover:text-blue-700"}`}
            onClick={() => {
              if (isInactive) return;
              setTaskId(item.taskId);
              setProjectId(item.projectId);
            }}
          >
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div
                    className={`truncate min-w-0 ${item.parentTaskId ? "italic" : ""}`}
                  >
                    {item.taskName}
                  </div>
                </TooltipTrigger>
                <TooltipContent>{item.taskName}</TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        );
      },
    },
    {
      key: "status",
      header: t("status"),
      sorting: true,
      onCellRender: (item: Task) => (
        <span
          className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(
            item.status,
          )}`}
        >
          {t(item.status)}
        </span>
      ),
    },
    {
      key: "startDate",
      header: t("start_date"),
      sorting: true,
      onCellRender: (item: Task) => (
        <>{dateFormater(new Date(item.startDate))}</>
      ),
    },
    {
      key: "endDate",
      header: t("end_date"),
      sorting: true,
      onCellRender: (item: Task) => (
        <>{dateFormater(new Date(item.dueDate ?? item.endDate))}</>
      ),
    },
    {
      key: "duration",
      header: t("Duration"),
      sorting: true,
      onCellRender: (item: Task) => <>{item.duration ?? 0}</>,
    },
    {
      key: "assignedUsers",
      header: t("assigned_to"),
      onCellRender: (item: Task) => (
        <div className="flex items-center gap-1 flex-wrap w-28 max-w-28">
          {(item.assignedUsers ?? []).slice(0, 3).map((a) => (
            <UserAvatar
              key={a.taskAssignUsersId ?? a.user?.email}
              user={a.user}
              className="w-6 h-6 shrink-0"
            />
          ))}
          {(item.assignedUsers?.length ?? 0) > 3 && (
            <span className="text-xs font-medium text-gray-500 bg-gray-100 rounded-full w-6 h-6 flex items-center justify-center shrink-0">
              +{(item.assignedUsers?.length ?? 0) - 3}
            </span>
          )}
        </div>
      ),
    },
    {
      key: "completionPecentage",
      header: t("progress"),
      sorting: true,
      onCellRender: (item: Task) => (
        <PercentageCircle
          percentage={item.completionPecentage ?? 0}
          roundColor={`${
            item.flag == "Green"
              ? "#34D399"
              : item.flag == "Red"
                ? "#FB7185"
                : item.flag == "Orange"
                  ? "#FBBF24"
                  : ""
          } `}
        />
      ),
    },
    {
      key: "Action",
      header: t("actions"),
      onCellRender: (item: Task) => (
        <>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <div className="cursor-pointer px-3 py-1.5 bg-transparent justify-center items-center gap-px inline-flex">
                <img src={NewEditIcon} className="mr-2 h-4 w-4" />
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-fit flex flex-col gap-1 bg-white shadow rounded">
              <DropdownMenuItem
                onClick={() => {
                  setTaskId(item.taskId);
                  setProjectId(item.projectId);
                }}
              >
                <img src={Edit} className="mr-2 h-4 w-4 " alt="" />
                <span className="p-0 font-normal h-auto">
                  {t("view_tasks")}
                </span>
              </DropdownMenuItem>
              <DropdownMenuSeparator className="mx-1" />
              {allowed(item) && (
                <DropdownMenuItem
                  onClick={() => setShowConfirmDelete(item.taskId)}
                >
                  <img src={TrashCan} className="mr-2 h-4 w-4 text-[#44546F]" />
                  <span className="p-0 font-normal h-auto text-red-500">
                    {t("remove")}
                  </span>
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </>
      ),
    },
  ];
  const contextMenuRef = useRef<HTMLDivElement>(null);
  const [contextMenuOption, setContextMenuOption] = useState<{
    contextMenuPosition: { x: number; y: number };
    contextMenuVisible: boolean;
    contextMenuTaskId: string | null;
    allowedMethods: ("edit" | "delete")[];
    clickedDate: Date | null;
  }>({
    contextMenuPosition: { x: 0, y: 0 },
    contextMenuVisible: false,
    contextMenuTaskId: null,
    allowedMethods: [],
    clickedDate: null,
  });
  const closeContextMenu = useCallback(() => {
    setContextMenuOption({
      allowedMethods: [],
      contextMenuPosition: { x: 0, y: 0 },
      contextMenuTaskId: null,
      contextMenuVisible: false,
      clickedDate: null,
    });
  }, []);
  useOutsideClick(contextMenuRef, closeContextMenu); // Hook to close menu on outside click
  useEffect(() => {
    if (allTaskQuery.data?.data.data) {
      setTaskData(
        setData(allTaskQuery.data?.data.data)?.sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
        ),
      );
      setFilterData(
        setData(allTaskQuery.data?.data.data)?.sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
        ),
      );
    }
  }, [allTaskQuery.data?.data.data]);

  useEffect(() => {
    if (searchParams.get("milestones")) {
      setFilterData(
        findParentTasksWithDoneMilsone(taskData ?? []).sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
        ),
      );
    }
    if (searchParams.get("status")) {
      setFilterData(
        findParentTasksWithDoneStatus(
          taskData ?? [],
          searchParams.get("status") ?? "",
        ).sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
        ),
      );
    }
    if (searchParams.get("flag")) {
      setFilterData(
        findParentTasksWithDoneFlag(
          taskData ?? [],
          searchParams.get("flag") ?? "",
        ).sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
        ),
      );
    }
  }, [taskData]);

  const getStatusColor = (status: string) => {
    switch (status) {
      case TaskStatusEnumValue.NOT_STARTED:
        return "bg-gray-100 text-gray-700";
      case TaskStatusEnumValue.IN_PROGRESS:
        return "bg-amber-100 text-amber-800";
      case TaskStatusEnumValue.COMPLETED:
        return "bg-green-100 text-green-800";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  const [searchParams] = useSearchParams();

  const setData = (tasks: Task[]) => {
    const taskMap = new Map<string, Task>();
    const rootTasks: Task[] = [];

    // Clone objects to avoid mutating API response
    tasks.forEach((task) => {
      taskMap.set(task.taskId, { ...task, subtasks: [...task.subtasks] });
    });

    // Attach children to parents
    taskMap.forEach((task) => {
      if (task.parentTaskId && taskMap.has(task.parentTaskId)) {
        const parent = taskMap.get(task.parentTaskId)!;
        parent.subtasks.push(task);
      } else {
        rootTasks.push(task);
      }
    });

    return rootTasks.map(convertTask);
  };

  const convertTask = (originalTask: Task) => {
    const convertedTask: Task & { tasks?: Task[] } = originalTask;
    if (originalTask.subtasks) {
      convertedTask.tasks = originalTask.subtasks.map((subtask) =>
        convertTask(subtask),
      );
    }

    return convertedTask;
  };

  const checkTaskStatus = (task: Task, status: string) => {
    if (task.subtasks && task.subtasks.length > 0) {
      const index = task.subtasks.findIndex((subtask) => {
        return checkTaskStatus(subtask, status);
      });
      return index !== -1;
    }
    return task.status === status;
  };

  function findParentTasksWithDoneStatus(tasks: Task[], status: string) {
    return tasks.filter((task) => {
      return checkTaskStatus(task, status);
    });
  }
  function findParentTasksWithDoneFlag(tasks: Task[], flag: string) {
    return tasks.filter((task) => {
      return checkTaskflag(task, flag);
    });
  }
  const checkTaskflag = (task: Task, flag: string) => {
    if (task.subtasks && task.subtasks.length > 0) {
      const index = task.subtasks.findIndex((subtask) => {
        return checkTaskflag(subtask, flag);
      });
      return index !== -1;
    }
    return task.flag === flag;
  };

  const checkTaskByMilsone = (task: Task) => {
    if (task.subtasks && task.subtasks.length > 0) {
      const index = task.subtasks.findIndex((subtask) => {
        return checkTaskByMilsone(subtask);
      });
      return index !== -1;
    }
    return Boolean(task.milestoneIndicator);
  };

  function findParentTasksWithDoneMilsone(tasks: Task[]) {
    return tasks.filter((task) => {
      return checkTaskByMilsone(task);
    });
  }
  const removeTaskMutation = useRemoveTaskMutation();
  const removeTask = () => {
    if (showConfirmDelete) {
      removeTaskMutation.mutate(showConfirmDelete, {
        onSuccess(data) {
          setShowConfirmDelete(null);
          allTaskQuery.refetch();
          toast.success(data.data.message);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig,
          );
        },
      });
    }
  };
  const onSelectTask = (taskId: string) => {
    const subTaskId: string[] = [taskId];
    const selectedTask = filterData?.find((ft) => ft.taskId == taskId);
    selectedTask?.subtasks.forEach((st) => {
      subTaskId.push(st.taskId);
    });

    if (!selectedTasks.includes(taskId)) {
      setSelectedTasks([...new Set([...(selectedTasks ?? []), ...subTaskId])]);
    } else {
      const removeTaskId = selectedTasks.filter((t) => !subTaskId.includes(t));
      setSelectedTasks(removeTaskId);
    }
  };
  const subTableRender = (task: Task, level = 0) => {
    return (
      <div
        className={`shadow-[0px_0px_34px_0px_#0000001A]  w-full  ${level == 0 && "ml-auto !w-[100%]"} ${
          level == 1 && "ml-auto !w-[100%]"
        } ${level == 2 && "ml-auto !w-[100%] "}`}
      >
        {task.subtasks.length > 0 && (
          <Table
            data={task.subtasks.sort(
              (a, b) =>
                new Date(a.startDate).getTime() -
                new Date(b.startDate).getTime(),
            )}
            columnDef={
              level >= 0
                ? columnDef.map((d) => {
                    return {
                      ...d,
                      className: () => {
                        return ``;
                      },
                    };
                  })
                : (columnDef ?? [])
            }
            onAccordionRender={(task) =>
              task.subtasks.length > 0 ? subTableRender(task, level + 1) : <></>
            }
            expandAll={expandAll}
            onRowClassName={(item) => isTaskProjectInactive(item) ? "!bg-gray-100/70 opacity-60 text-gray-400 pointer-events-none select-none" : ""}
            className="border-0 !px-0 !rounded-none [&>*]:!overflow-x-hidden [&>*]:!overflow-y-hidden !bg-zinc-100"
            hidePagination={true}
            hideHeaders={true}
          />
        )}
      </div>
    );
  };
  const multipaleTaskRemoveMutation = useMultipaleTaskRemoveMutation();
  const removetask = () => {
    multipaleTaskRemoveMutation.mutate(
      { taskIds: selectedTasks },
      {
        onSuccess: (data) => {
          toast.success(data.data.message);
          setRemove(false);
          allTaskQuery.refetch();
          setSelectedTasks([]);
        },
        onError(err) {
          toast.error(
            errorKeyFormate(err.response?.data.message + ""),
            errorConfig,
          );
        },
      },
    );
  };

  useEffect(() => {
    if (!projects.isFetched) {
      projects.refetch();
    }
  }, [])
  
  const allowed = useCallback((task: Task | undefined) => {
    const project = projects.data?.data.data.find(
      (p) => p.projectId == task?.projectId
    );
    if (project && !project.isActive) {
      return false;
    }
    if (
      task &&
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user.user?.userId &&
          u.projectRole == UserRoleEnumValue.TEAM_MEMBER,
      ) &&
      task.createdByUserId == user.user?.userId
    ) {
      return true;
    } else if (
      project?.assignedUsers.some(
        (u) =>
         ( u.user.userId == user.user?.userId &&
          u.projectRole == UserRoleEnumValue.PROJECT_MANAGER)) || user.user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR
    ) {
      return true;
    } else {
      return false;
    }
  },[projects.data?.data.data,user.user,projectId]);
  const allowedContextActions = useCallback(
    (taskId: string | null) => {
      const projectId = taskData?.find(
        (task) => task.taskId == taskId,
      )?.projectId;
      const project = projects.data?.data.data.find(
        (p) => p.projectId == projectId,
      );
      const allowedActions: ("edit" | "delete")[] = [];
      const projectRole = project?.assignedUsers.find(
        (projectUser) => projectUser.user.userId == user?.user?.userId,
      )?.projectRole as keyof typeof UserRoleEnumValue;
      if (taskId) {
        const task = taskData?.find((task) => task.taskId == taskId);
        if (
          (task &&
            user?.user?.userOrganisation[0].role ==
              UserRoleEnumValue.ADMINISTRATOR) ||
          projectRole == UserRoleEnumValue.PROJECT_MANAGER ||
          projectRole == UserRoleEnumValue.ADMINISTRATOR
        ) {
          allowedActions.push("edit", "delete");
        } else if (
          task &&
          projectRole == UserRoleEnumValue.TEAM_MEMBER &&
          task.createdByUserId == user?.user?.userId
        ) {
          allowedActions.push("edit", "delete");
        } else if (
          task &&
          projectRole == UserRoleEnumValue.TEAM_MEMBER &&
          task.assignedUsers.find(
            (taskUser) => taskUser.user.userId == user?.user?.userId,
          ) &&  task.createdByUserId == user.user?.userId
        ) {
          allowedActions.push("edit");
        }else if (
          task &&
          projectRole == UserRoleEnumValue.TEAM_MEMBER &&
          task.assignedUsers.find(
            (taskUser) => taskUser.user.userId == user?.user?.userId,
          )
        ) {
          allowedActions.push("edit");
        } else if (projectRole == UserRoleEnumValue.COLLABORATOR) {
          allowedActions.push("edit");
        }
        return allowedActions;
      }
      return allowedActions;
    },
    [user?.user?.userId,taskData,
projects.data?.data.data],
  );
  const days = [
    { lable: "SUN", value: 0 },
    { lable: "MON", value: 1 },
    { lable: "TUE", value: 2 },
    { lable: "WED", value: 3 },
    { lable: "THU", value: 4 },
    { lable: "FRI", value: 5 },
    { lable: "SAT", value: 6 },
  ];
  const nonWorkingDays = () => {
    const nonworkingDays: (number | undefined)[] = [];
    user?.user?.userOrganisation[0].organisation.nonWorkingDays.forEach(
      (day) => {
        if (day) {
          nonworkingDays.push(days.find((d) => d.lable == day)?.value);
        }
      },
    );
    return nonworkingDays;
  };
  const DataConvertToScheduler = (task: Task): SchedulerEvent => {
    return {
      id: task.taskId,
      status: task.status,
      dateStart: task.startDate,
      dateEnd:
        task.milestoneIndicator && task.dueDate
          ? new Date(task.dueDate)
          : new Date(task.endDate),
      label: task.taskName,
      description: task.taskDescription,
      backgroundColor:
        task.flag == "Green"
          ? "#22c55e80"
          : task.flag == "Red"
            ? "#EF444480"
            : task.flag == "Orange"
              ? "#F9980780"
              : "#88888880",
      disableDrag: true,
      disableResize: true,
    };
  };

  const enterFullscreen = () => {
    const elem = document.documentElement;

    if (!isFullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  const statusOptions = ["Non commencé", "Terminé", "En cours"];
  const [expandAll, setExpandAll] = useState(false);
  const downloadExcel = async (data: Task[]) => {
    const projectName = "Project";

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Feuille1");

    worksheet.columns = [
      { header: "ID", key: "id", width: 10 },
      { header: "Activites / Taches", key: "task", width: 40 },
      { header: "Date de debut (optionel)", key: "startDate", width: 20 },
      { header: "Duree (optionel)", key: "duration", width: 20 },
      { header: "Date de fin (optionnel)", key: "endDate", width: 20 },
      { header: "Assigné à", key: "assignedTo", width: 25 },
      { header: "Statut", key: "status", width: 18 },
      { header: "Progrès", key: "progress", width: 12 },
      { header: "Jalon", key: "milestone", width: 10 },
    ];

    const flattenedTasks: {
      id: string;
      task: string;
      startDate: string;
      duration: number | string;
      endDate: string;
      assignedTo: string;
      status: string;
      progress: string;
      milestone: string;
    }[] = [];

    const formatTask = (
      task: Task,
      indexPath: string,
    ): (typeof flattenedTasks)[number] => {
      const mainTask = data.find((t) => t.taskId == task.taskId);
      const assignees = (mainTask?.assignedUsers || [])
        .map((u) => {
          const { email } = u.user || {};
          return email || "";
        })
        .join(" ");

      let status = "Non commencé";
      if (task.status === TaskStatusEnumValue.COMPLETED) status = "Terminé";
      else if (task.status === TaskStatusEnumValue.IN_PROGRESS)
        status = "En cours";
      const endDate = mainTask?.endDate;
      console.log({
        id: indexPath,
        task: task.taskName,
        startDate: task.startDate ? dateFormater(task.startDate) : "",
        duration: task.duration || "",
        endDate: dateFormater(new Date(endDate ?? "")),
        assignedTo: assignees,
        status,
        progress: Number(task.completionPecentage).toFixed(),
        milestone: task.milestoneIndicator ? "true" : "false",
      });
      return {
        id: indexPath,
        task: task.taskName,
        startDate: task.startDate ? dateFormater(task.startDate) : "",
        duration: task.duration || "",
        endDate: dateFormater(new Date(endDate ?? "")),
        assignedTo: assignees,
        status,
        progress: Number(task.completionPecentage).toFixed(),
        milestone: task.milestoneIndicator ? "true" : "false",
      };
    };

    const traverseTasks = (tasks: Task[], prefix = "") => {
      tasks.forEach((task, i) => {
        const idPath = prefix ? `${prefix}.${i + 1}` : `${i + 1}`;
        flattenedTasks.push(formatTask(task, idPath));
        if (task.subtasks?.length) {
          traverseTasks(task.subtasks, idPath);
        }
      });
    };

    traverseTasks(
      data.sort(
        (a, b) =>
          new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
      ),
    );

    flattenedTasks.forEach((taskRow) => {
      const row = worksheet.addRow(taskRow);

      const isParent = /^\d+$/.test(taskRow.id); // IDs like "1", "2" only

      if (isParent) {
        row.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "B9E1CB" }, // Light Green
          };
          cell.font = { bold: true };
        });
      }
    });

    worksheet.eachRow((_, rowNumber) => {
      if (rowNumber === 1) return;

      worksheet.getCell(`G${rowNumber}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${statusOptions.join(",")}"`],
        showErrorMessage: true,
      };

      worksheet.getCell(`I${rowNumber}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"true,false"'],
        showErrorMessage: true,
      };
    });

    // Set header row styling
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "62BD8A" }, // Dark Green
      };
      cell.font = {
        bold: true,
        color: { argb: "FFFFFF" }, // White
      };
      cell.border = {
        top: { style: "thin", color: { argb: "006400" } },
        left: { style: "thin", color: { argb: "006400" } },
        bottom: { style: "thin", color: { argb: "006400" } },
        right: { style: "thin", color: { argb: "006400" } },
      };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${projectName}.xlsx`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="h-full overflow-hidden">
      {allTaskQuery.isFetching ||
      allTaskQuery.isRefetching ||
      filterData === undefined ? (
        <Loader key={"list"} className="absolute top-0 left-0" />
      ) : (
        <>
          <>
            <div className="w-full flex flex-col gap-3 px-6 pt-4 pb-2 h-full">
              <div className="flex flex-wrap justify-between items-center gap-3">
                <div className="flex flex-wrap items-center gap-3">
                  <TaskFilter
                    fieldToShow={[
                      // FIELDS.ASSIGNED,
                      FIELDS.DATE,
                      FIELDS.DUESEVENDAYS,
                      FIELDS.FLAGS,
                      FIELDS.OVERDUEDAYS,
                      FIELDS.TODAYDUEDAYS,
                      FIELDS.PROJECTS,
                    ]}
                    view={ProjectDefaultViewEnumValue.LIST}
                    filteredData={(data) => {
                      setFilterData(
                        setData(data ?? [])?.sort(
                          (a, b) =>
                            new Date(a.startDate).getTime() -
                            new Date(b.startDate).getTime(),
                        ),
                      );
                    }}
                    tasks={taskData}
                  />
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <li className="list-none">
                          <Button
                            variant={"none"}
                            onClick={() => setExpandAll(!expandAll)}
                            size={"sm"}
                          >
                            <img
                              src={!expandAll ? Collaps : Expand}
                              alt=""
                              className="w-4 min-w-4"
                            />
                          </Button>
                        </li>
                      </TooltipTrigger>
                      <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                        <p className="text-sm">
                          {t(!expandAll ? "expand" : "collapse")}
                        </p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <li className="flex-1 list-none">
                          <Button
                            variant={"none"}
                            className="select-none  !p-1"
                            onClick={() => enterFullscreen()}
                            size={"sm"}
                          >
                            <img
                              src={!isFullscreen ? FullScreen : ExitFullscreen}
                              className="w-4 min-w-4"
                            />
                          </Button>
                        </li>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">
                          {t(
                            !isFullscreen ? "full_Screen" : "full_exit_screen",
                          )}
                        </p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <li className="flex-1 list-none">
                          <Button
                            variant={"none"}
                            className="select-none  !p-1"
                            onClick={() => allTaskQuery.refetch()}
                            size={"sm"}
                          >
                            <img src={Refresh} className="w-4 min-w-4" />
                          </Button>
                        </li>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">{t("reload")}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                  <TooltipProvider>
                    <Tooltip delayDuration={0}>
                      <TooltipTrigger asChild>
                        <li className="flex-1 list-none">
                          <Button
                            variant={"none"}
                            className=" !p-1"
                            onClick={() => downloadExcel(filterData ?? [])}
                            size={"sm"}
                          >
                            <img src={ExcelIcon} className="w-4 min-w-4" />
                            <img
                              src={DownLoadIcon}
                              className="w-2 min-w-2 mt-2"
                            />
                          </Button>
                        </li>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">{t("export your task")}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                  {selectedTasks.length > 0 && (
                    <Button
                      variant={"destructive"}
                      onClick={() => setRemove(true)}
                      className=" "
                    >
                      {t("remove")}
                    </Button>
                  )}
                </div>

                <div className="flex items-center gap-0 rounded-3xl border border-gray-200 overflow-hidden p-1 bg-gray-50/80">
                  {viewOption.map((item) => (
                    <button
                      key={item.value}
                      type="button"
                      onClick={() => setViews(item.value)}
                      className={`flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors rounded-3xl ${
                        item.value === views
                          ? "bg-orange text-white shadow-sm"
                          : "bg-transparent text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                      }`}
                    >
                      <span>
                        {item.value === ProjectDefaultViewEnumValue.LIST
                          ? t("List View")
                          : t("Calendar View")}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
              <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
                {views == ProjectDefaultViewEnumValue.LIST && (
                  <div className="flex-1 min-h-0 overflow-auto">
                    <Table
                      expandAll={expandAll}
                      columnDef={columnDef}
                      data={filterData ?? []}
                      onAccordionRender={(task) => subTableRender(task)}
                      onRowClassName={(item) => isTaskProjectInactive(item) ? "!bg-gray-100/70 opacity-60 text-gray-400 pointer-events-none select-none" : ""}
                      className="!pt-9 !pb-0 !sm:pb-7 !h-full min-h-[400px]"
                      hederClassName="h-[65px]"
                    ></Table>
                  </div>
                )}

                {views == ProjectDefaultViewEnumValue.CALENDAR && (
                  <div className="flex-1 min-h-0 flex flex-col gap-2 overflow-hidden">
                    <Scheduler
                      key={views}
                      id="scheduler"
                      dataSource={dataSource}
                      view="month"
                      nonworkingDays={nonWorkingDays()}
                      draggable={false}
                      hideNonworkingWeekdays={true}
                      className="flex-1 min-h-[400px] scheduler"
                      onContextMenuOpening={(e) => {
                        const event = e as CustomEvent & Event;
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();

                        const x = event.detail?.target?.offsetLeft || 0;
                        const y = event.detail?.target?.offsetTop || 0;
                        const allowedAction = allowedContextActions(
                          event.detail?.eventObj?.[0]?.id ?? null,
                        );
                        
                        if (allowedAction.length == 0) {
                          setContextMenuOption({
                            contextMenuPosition: {
                              x: 0,
                              y: 0,
                            },
                            contextMenuVisible: false,
                            contextMenuTaskId: null,
                            allowedMethods: [],
                            clickedDate: null,
                          });
                        } else {
                          setContextMenuOption({
                            contextMenuPosition: {
                              x,
                              y,
                            },
                            contextMenuVisible: true,
                            contextMenuTaskId:
                              event.detail?.eventObj?.[0]?.id || null,
                            allowedMethods: allowedAction,
                            clickedDate:
                              event.detail?.eventObj?.[0]?.dateStart ??
                              event.detail?.cellObj?.date ??
                              null,
                          });
                        }
                      }}
                      locale={i18n.language}
                      messages={{
                        [i18n.language]: i18n.getDataByLanguage(i18n.language)
                          ?.translations,
                      }}
                      onEditDialogOpening={(e) =>
                        onItemClick(e as (Event & CustomEvent) | undefined)
                      }
                    ></Scheduler>
                    {dialogRendered && (
                      <TaskSubTaskForm
                        close={close}
                        taskId={dialogRendered ?? undefined}
                        projectId={projectId}
                        initialValues={{ startDate: startDate }}
                      />
                    )}
                  </div>
                )}
              </div>
              {contextMenuOption.contextMenuVisible && (
                <div
                  ref={contextMenuRef} // Assign ref
                  style={{
                    position: "fixed", // Use fixed positioning relative to viewport
                    top: `${contextMenuOption.contextMenuPosition.y}px`,
                    left: `${contextMenuOption.contextMenuPosition.x}px`,
                    zIndex: 50, // Ensure it's above other elements
                  }}
                  className="bg-white border border-gray-300 rounded-md shadow-lg py-1 min-w-[80px]"
                  onClick={(e) => e.stopPropagation()} // Prevent clicks inside from closing it immediately
                  onContextMenu={(e) => e.preventDefault()} // Prevent context menu from showing
                >
                  {contextMenuOption.allowedMethods.includes("edit") && (
                    <div
                      className="px-3 py-1.5 text-sm hover:bg-gray-100 cursor-pointer"
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        setDialogRendered(
                          contextMenuOption.contextMenuTaskId ?? undefined,
                        );
                        closeContextMenu();
                      }}
                    >
                      {t("Edit")}
                    </div>
                  )}
                  {contextMenuOption.allowedMethods.includes("delete") && (
                    <div
                      className="px-3 py-1.5 text-sm hover:bg-gray-100 cursor-pointer text-red-600"
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        setShowConfirmDelete(
                          contextMenuOption.contextMenuTaskId,
                        );
                        closeContextMenu();
                      }}
                    >
                      {t("Delete")}
                    </div>
                  )}
                </div>
              )}
            </div>
          </>

          {(Boolean(taskId) || taskCreate) && (
            <TaskSubTaskForm
              taskId={taskId}
              projectId={projectId}
              close={close}
            />
          )}
          <Dialog
            isOpen={Boolean(showConfirmDelete)}
            onClose={() => {}}
            modalClass="rounded-lg"
          >
            <div className="flex flex-col gap-2 p-6 ">
              <img src={TrashCan} className="w-12 m-auto" />{" "}
              {t("common_delete_message")}
              <div className="flex gap-2 ml-auto">
                <Button
                  variant={"outline"}
                  isLoading={removeTaskMutation.isPending}
                  disabled={removeTaskMutation.isPending}
                  onClick={() => setShowConfirmDelete(null)}
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant={"primary"}
                  onClick={removeTask}
                  isLoading={removeTaskMutation.isPending}
                  disabled={removeTaskMutation.isPending}
                >
                  {t("delete")}
                </Button>
              </div>
            </div>
          </Dialog>
          <Dialog isOpen={remove} onClose={() => {}} modalClass="rounded-lg">
            <div className="flex flex-col gap-2 p-6 ">
              <img src={TrashCan} className="w-12 m-auto" />{" "}
              {t("common_delete_message")}
              <div className="flex gap-2 ml-auto">
                <Button
                  variant={"outline"}
                  isLoading={multipaleTaskRemoveMutation.isPending}
                  disabled={multipaleTaskRemoveMutation.isPending}
                  onClick={() => setRemove(false)}
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant={"primary"}
                  className="text-white"
                  onClick={removetask}
                >
                  {t("delete")}
                </Button>
              </div>
            </div>
          </Dialog>
        </>
      )}
    </div>
  );
}

export default MyTasks;
